__turbopack_context__.v({
  "guestCustomer": "NavbarUserProfile-module-scss-module__MUfKPa__guestCustomer",
  "outletDetailsPage": "NavbarUserProfile-module-scss-module__MUfKPa__outletDetailsPage",
  "profileContent": "NavbarUserProfile-module-scss-module__MUfKPa__profileContent",
  "profileDropdownButton": "NavbarUserProfile-module-scss-module__MUfKPa__profileDropdownButton",
  "profileDropdownPopup": "NavbarUserProfile-module-scss-module__MUfKPa__profileDropdownPopup",
  "profileIcon": "NavbarUserProfile-module-scss-module__MUfKPa__profileIcon",
  "profileName": "NavbarUserProfile-module-scss-module__MUfKPa__profileName",
  "profileUserName": "NavbarUserProfile-module-scss-module__MUfKPa__profileUserName",
  "whiteLabeled": "NavbarUserProfile-module-scss-module__MUfKPa__whiteLabeled",
});
